import styled from 'styled-components';


const PaymentAcknowledgeWrapper = styled.div`
.p-checkbox {width: 24px;height: 24px;margin-right: 05px;}
.p-checkbox .p-checkbox-box {border: solid 1px #00000080;background: #ffffff;width: 24px;height: 24px;color: #495057;border-radius: 0px;transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;}
.p-checkbox .p-checkbox-box.p-highlight {border-color: #6B47F5;background: #6B47F5;}
.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {border-color: #6B47F5;background: #6B47F5;color: #ffffff;}
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {border-color: #6B47F5;}
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {box-shadow: none;}
.p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {border-color: #6B47F5;background: #6B47F5;color: #ffffff;}      
.p-input-filled .p-checkbox .p-checkbox-box {background-color: #e9ecef;}
.p-input-filled .p-checkbox .p-checkbox-box.p-highlight {background: #6B47F5;}
.p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {background-color: #e9ecef;}
.p-input-filled .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {background: #6B47F5;}
label {font-size: 13px;line-height: 1.04;color: #4c565c;}
.cover-amount {text-align: right;
  p{color:#fff;padding: 4px 5px;border-radius: 100px;background-color: #818b9b;float: right;font-size:11px;}
  }

  .p-accordion-header{
    display: none
  }
  .p-accordion .p-accordion-content{
    background: #fff;
    border: 0;
    // padding: 1.25rem 0
  }
  label{
    button{
      color: #6B47F5 !important;
      text-decoration: underline !important;
      cursor: pointer;
      font-size:13px;
      &:focus{
        box-shadow:none !important;
      }
    }
  }

  
`;

export default PaymentAcknowledgeWrapper;